import * as React from 'react'

import { Box } from '~ui/components/layout/Box'
import { durations } from '~ui/styleGuide/styles'

import { StyledAnimatedHeight } from './StyledAnimatedHeight'
import { useAnimatedHeight } from './useAnimatedHeight'

type TProps = RequiredChildren & FirstParam<typeof useAnimatedHeight>

/**
 * component for animating height of React components
 * - keeps the children render for the time of the closing animation
 * - animates container height based on children height changes (for height: `auto` animations)
 * basic usage: wrap the animated content in this component & provide dynamic `isOpen` prop
 */
export const AnimatedHeight: React.FC<TProps> = ({
  isOpen,
  children,
  closedSize,
  animationTimeMs = durations.basic,
}) => {
  const { refContent, shouldRenderContent, containerHeight } = useAnimatedHeight({
    isOpen,
    children,
    closedSize,
    animationTimeMs,
  })

  return (
    <StyledAnimatedHeight height={containerHeight} animationTimeMs={animationTimeMs}>
      <Box ref={refContent}>{shouldRenderContent && children}</Box>
    </StyledAnimatedHeight>
  )
}
